import axios from "axios";
import i18n from '../i18n';

const axiosInstance = axios.create({
  baseURL: "https://app-test.baskeg.com/api",
  // baseURL: "https://app.baskeg.com/api",
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
    "api-key":
      "KpoKcXyjTCHxPquIyTLByode9ZioJ4NwRh4CAFwY5mgoOtw91iuda1Kh0duBaJkR",
  },
});

// Flag to prevent multiple refresh attempts
let isRefreshing = false;
let failedQueue = [];

const processQueue = (error, token = null) => {
  failedQueue.forEach(prom => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });
  
  failedQueue = [];
};

axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    
    // Add language header based on current i18n language
    const currentLanguage = i18n.language || 'en';
    config.headers["Accept-Language"] = currentLanguage;
    config.headers["locale"] = currentLanguage;
    
    return config;
  },
  (error) => {
    console.log(error);
    return Promise.reject(error);
  }
);

// Response interceptor for handling token refresh
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  async (error) => {
    const originalRequest = error.config;

    // Check if error is 401 and we haven't already tried to refresh
    if (error.response?.status === 401 && !originalRequest._retry) {
      if (isRefreshing) {
        // If already refreshing, queue this request
        return new Promise((resolve, reject) => {
          failedQueue.push({ resolve, reject });
        }).then(token => {
          originalRequest.headers['Authorization'] = 'Bearer ' + token;
          return axiosInstance(originalRequest);
        }).catch(err => {
          return Promise.reject(err);
        });
      }

      originalRequest._retry = true;
      isRefreshing = true;

      try {
        const refreshToken = localStorage.getItem("refreshtoken");
        if (!refreshToken) {
          throw new Error("No refresh token available");
        }

        // Attempt to refresh the token
        const response = await axios.get(`${axiosInstance.defaults.baseURL}/v1/users/auth/refresh`, {
          headers: {
            refresh_token: refreshToken,
          },
        });

        const newToken = response.data.token;
        localStorage.setItem("token", newToken);
        
        // Update the authorization header for the original request
        originalRequest.headers['Authorization'] = 'Bearer ' + newToken;
        
        // Process queued requests
        processQueue(null, newToken);
        
        // Retry the original request
        return axiosInstance(originalRequest);
      } catch (refreshError) {
        console.error("Token refresh failed:", refreshError);
        
        // Clear tokens and redirect to login
        localStorage.removeItem("token");
        localStorage.removeItem("refreshtoken");
        
        // Process queued requests with error
        processQueue(refreshError, null);
        
        // Redirect to login page
        window.location.href = "/";
        
        return Promise.reject(refreshError);
      } finally {
        isRefreshing = false;
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
